import classNames from 'classnames';
import React from 'react';
import ProductContainer from './Container';
import ProductAddCart from './meta/add-cart';
import CardBody from './meta/card-body/card-body-vertical';
import CardHeadVertical from './meta/card-head/card-head-vertical';
import type { ProductCardProps } from './types';
import EnchancedFavorite from './meta/enchanced-favorite';

const ProductVertical: React.FC<Partial<ProductCardProps>> = props => {
  const { className, ...rest } = props;
  return (
    <ProductContainer
      interactiveSlot={
        <div
          className="absolute right-0 top-0 w-full pointer-events-none"
          style={{
            paddingTop: '100%'
          }}>
          <EnchancedFavorite {...props} />
          {React.cloneElement(<ProductAddCart {...props} />, props)}
        </div>
      }
      {...rest}>
      <div className={classNames('p-0')}>
        <CardHeadVertical {...rest} showFavorite={false} />
        <CardBody {...rest} />
      </div>
    </ProductContainer>
  );
};

export default ProductVertical;
